import {create} from 'zustand';
import {FinancialDataType} from 'domain/usecases';
import {UseFinancialDataStoreProps} from './types';

export const useFinancialDataStore = create<UseFinancialDataStoreProps>(set => ({
	data: {} as FinancialDataType,
	setData: data => set({data}),
	resetData: () => set({data: {} as FinancialDataType}),
}));
